export default __webpack_public_path__ + "static/jaqueta-cone-45eda3e99649469983a27558b5a67d55.png";